import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { deleteMAGAC020, getMAGAC020, getMAGAC020options } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS, MESSAGE } from '../../../shared/constants/app';
import { getImageSrc } from '../../../utils';

const MAGAC040 = () => {
    const { id } = useParams();
    const [data, setData] = useState({});
    const [fileData, setFileData] = useState({});
    const [appGbnTarget, setAppGbnTarget] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (id) {
                    const { data } = await getMAGAC020(id);
                    setData({
                        ...data,
                        seq: id,
                    });
                    setFileData({
                        webImg: {
                            name: data?.webImg,
                            preview: getImageSrc('event', data?.webImg),
                        },
                        appImg: {
                            name: data?.appImg,
                            preview: getImageSrc('event', data?.appImg),
                        },
                    });
                }
                const { data: optionsData } = await getMAGAC020options();
                setAppGbnTarget(optionsData);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, [id]);

    const formatDate = (date) => (date ? moment(date).locale('ko').format('YYYY.MM.DD') : '');
    const handleDelete = () => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAGAC020(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    window.location.href = '/magac010';
                })
                .catch((error) => console.log(error));
        }
    };
    const getTargetSiteText = (value) => {
        switch (value) {
            case 'ALL':
                return 'Web, App';
            case 'WEB':
                return 'Web (PC)';
            case 'MOB':
                return 'App (Mobile)';
            default:
                return '선택';
        }
    };
    const getEventGbnText = (value) => {
        switch (value) {
            case 'EVT':
                return '일반(안내형 이벤트)';
            case 'RVW':
                return '댓글';
            default:
                return '';
        }
    };
    const getTargetText = (value) => {
        switch (value) {
            case 'A':
                return '전체';
            case 'C':
                return '치과회원';
            case 'P':
                return '개인회원';
            default:
                return '';
        }
    };

    const getIsEndText = (value) => {
        switch (value) {
            case '':
                return '진행예정';
            case 'N':
                return '진행';
            case 'Y':
                return '마감';
            default:
                return '';
        }
    };

    const getIsRegisteredText = (value) => {
        switch (value) {
            case 'Y':
                return '등록';
            case 'N':
                return '미등록';
            default:
                return '';
        }
    };

    const getOptions = () => {
        const defaultOptions = [{ id: 'target_A', value: 'A', label: '전체' }];
        const additionalOptions = appGbnTarget.map((target) => ({
            id: 'target_' + target.code,
            value: target.code,
            label: target.codeName,
        }));
        return [...defaultOptions, ...additionalOptions];
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div id="tableVolunteer" style={{ width: '100%' }}>
                    {/* <h3 className="vln__tit">이벤트</h3> */}
                    <div className="vln-edtl">
                        <div className="vln-edtl__tit">
                            <div className="vln-edtl-lf">
                                <span className={data?.isEnd === 'Y' ? 'gray' : ''}>
                                    {data?.isEnd === 'Y' ? '마감' : '진행중'}
                                </span>
                                <p>{data?.title}</p>
                            </div>
                            <div className="vln-edtl__date">
                                {formatDate(data?.startDate)} ~ {formatDate(data?.endDate)}
                            </div>
                        </div>
                        <table className="table member-infor">
                            <tbody>
                                {/* <tr>
                                    <th className="border-t-ddd">채널</th>
                                    <td colSpan={3} className="border-t-ddd">
                                        {getTargetSiteText(data?.targetSite)}
                                    </td>
                                </tr> */}
                                <tr>
                                    <th className="border-t-ddd">이벤트 타입</th>
                                    <td colSpan={3} className="border-t-ddd">
                                        {getEventGbnText(data?.eventGbn)}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="border-t-ddd">대상회원</th>
                                    <td colSpan={3} className="border-t-ddd">
                                        {getTargetText(data?.target)}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="border-t-ddd">회원구분(선택)</th>
                                    <td colSpan={3}>
                                        <div className="d-flex flex-wrap gap-3">
                                            {' '}
                                            {(() => {
                                                const selectedValues = (data?.appGbnTarget || '')
                                                    .split(',')
                                                    .map((v) => v.trim())
                                                    .filter(Boolean);
                                                const options = getOptions();
                                                const labels = options
                                                    .filter((opt) => selectedValues.includes(opt.value))
                                                    .map((opt) => opt.label);
                                                return labels.join(', ');
                                            })()}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>진행기간</th>
                                    <td>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">{formatDate(data?.startDate)}</div>
                                                <span>~</span>
                                                <div className="datepicker-child">{formatDate(data?.endDate)}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <th>진행상태</th>
                                    <td className="border-t-ddd">{getIsEndText(data?.isEnd)}</td>
                                </tr>
                                {/* <tr>
                                    <th>사이트 등록여부</th>
                                    <td>{getIsRegisteredText(data?.isRegistered)}</td>
                                    <th>공개여부</th>
                                    <td>{data?.dspYN === 'N' ? '비공개' : data?.dspYN === 'Y' ? '공개' : ''}</td>
                                </tr> */}
                                <tr>
                                    <th>APP 썸네일</th>
                                    <td colSpan={3}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <div
                                                className="result-input-file"
                                                style={{ width: '200px', objectFit: 'contain' }}
                                            >
                                                {fileData.appImg?.preview && (
                                                    <img
                                                        src={fileData.appImg.preview}
                                                        alt="Preview"
                                                        className="event__image"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>WEB 썸네일</th>
                                    <td colSpan={3}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <div
                                                className="result-input-file"
                                                style={{ width: '200px', objectFit: 'contain' }}
                                            >
                                                {fileData.webImg?.preview && (
                                                    <img
                                                        src={fileData.webImg.preview}
                                                        alt="Preview"
                                                        className="event__image"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="border-t-ddd">상세내용 (WEB)</th>
                                    <td colSpan={3}>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: data?.contents }}
                                            style={{ padding: '20px 0' }}
                                        ></div>
                                    </td>
                                </tr>

                                <tr>
                                    <th className="border-t-ddd">상세내용 (APP)</th>
                                    <td colSpan={3}>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: data?.contentsApp }}
                                            style={{ padding: '20px 0' }}
                                        ></div>
                                    </td>
                                </tr>
                                {/* <tr>
                                    <th className="border-t-ddd">연결 URL</th>
                                    <td colSpan={3} className="border-t-ddd">
                                        {data?.surveyLink || ''}
                                    </td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <div className="bottom-content" style={{ justifyContent: 'start', gap: '15px' }}>
                        <div className="button-form">
                            <Link to={'/magac010'} className="btn btn-primary button-back-to-list">
                                목록
                            </Link>
                        </div>
                        <div className="button-form">
                            <button
                                className="btn btn-primary button-back-to-list button-delete"
                                onClick={() => {
                                    handleDelete();
                                }}
                            >
                                삭제
                            </button>
                        </div>
                        <div className="button-form">
                            <Link to={`/magac020-${id}`} className="btn btn-primary button-save">
                                수정
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAC040;
